import { clsx } from 'clsx';
import { useExperiment } from '@hungryroot/experiments';
import { Badge } from '@hungryroot/pho';
import { TransparentButton, Paragraph } from '@hungryroot/ramen';
import styles from './IngredientsList.module.css';

interface Ingredient {
  id: number;
  discount?: number | null;
  name: string;
  subText: string;
  imageUrl: string | null;
  isRemoved?: boolean;
  amount?: number;
}

interface IngredientsListProps {
  ingredients: Ingredient[];
  onClick?: (ingredient: Ingredient) => void;
  className?: string;
}

export function IngredientsList(props: IngredientsListProps) {
  const { ingredients, className, onClick } = props;
  const itemLevelDiscountsExperiment = useExperiment(203);

  const isItemLevelDiscountsEnabled =
    itemLevelDiscountsExperiment !== undefined &&
    itemLevelDiscountsExperiment > 0;

  return (
    <>
      <div
        className={`${styles.container} ${styles['ingredients-list']} ${className}`}
      >
        {ingredients.map((ingredient) => {
          const {
            id: ingredientId,
            discount,
            imageUrl,
            name,
            subText,
            isRemoved,
            amount,
          } = ingredient;
          const showDiscounts =
            isItemLevelDiscountsEnabled && discount && discount > 0;
          return (
            <TransparentButton
              className={clsx({
                [styles.ingredients]: true,
                [styles.removed]: isRemoved,
                [styles.arrow]: !onClick,
              })}
              key={ingredientId}
              onClick={() => {
                onClick?.(ingredient);
              }}
            >
              {imageUrl !== null && (
                <img
                  className={`${styles['image']}`}
                  src={imageUrl}
                  alt="food-img"
                />
              )}
              <div className={styles['text-container']}>
                <Paragraph variant="body">{name}</Paragraph>
                <Paragraph className={`${styles['subtext']}`} variant="caption">
                  {subText}
                </Paragraph>
              </div>
              {showDiscounts && (
                <Badge variant="Sale">
                  <Paragraph variant="caption">Sale</Paragraph>
                </Badge>
              )}
              {amount && amount > 1 && <Paragraph>x{amount}</Paragraph>}
              {isRemoved && (
                <Paragraph className={styles['removed-text']}>
                  Removed
                </Paragraph>
              )}
            </TransparentButton>
          );
        })}
      </div>
    </>
  );
}
